import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=33794715&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33794715",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33794715')) {
      api.createRecord('33794715', component.options)
    } else {
      api.reload('33794715', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=33794715&scoped=true", function () {
      api.rerender('33794715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/banner.vue"
export default component.exports